$.fn.extend({
  addTabErrors() {
    const element = this;

    $('.ui.tab').each((idx, el) => {
      const errors = $(el).find('.sylius-validation-error');

      if (errors.length !== 0) {
        const tabName = $(el).attr('data-tab');
        const tabWithErrors = $(element).find(`a.item[data-tab="${tabName}"]`);

        if (tabWithErrors.length > 1) return;

        const label = tabWithErrors.html();
        const newLabel = `${label}<span class="ui small horizontal circular label" style="background-color: #DB2828">${errors.length}</span>`;

        tabWithErrors.html(newLabel);
      }
    });
  },
  addDictionaryTabErrors() {
    $('.ui.tab.second').each((i, secondLevelElement) => {
      $(secondLevelElement).find('.ui.tab').each((l, thirdLevelElement) => {
        const thirdLevelErrors = $(thirdLevelElement).find('.sylius-validation-error');

        if (thirdLevelErrors.length === 0) return;

        const thirdLevelTabName = $(thirdLevelElement).attr('data-tab');
        const thirdLevelTabItem = $(secondLevelElement).find(`a.item[data-tab="${thirdLevelTabName}"]`);

        const thirdLevelTabItemLabel = thirdLevelTabItem.html();
        const thirdLevelTabItemNewLabel = `${thirdLevelTabItemLabel}<span class="ui small horizontal circular label" style="background-color: #DB2828">${thirdLevelErrors.length}</span>`;

        thirdLevelTabItem.html(thirdLevelTabItemNewLabel);

        const secondLevelTabName = $(secondLevelElement).attr('data-tab');
        const firstLevelTabName = $(secondLevelElement).attr('data-tab-first');

        $(`[data-tab="${firstLevelTabName}/${secondLevelTabName}"]`).addClass('error')
        $(`[data-tab="${firstLevelTabName}"]`).addClass('error');
      })
    });
  },
});
